import type { PageResult } from '@/features/employees/types';
import { api } from '@/shared/api/client';

export interface Notification {
  id: number;
  kind: string;
  entity: string;
  entityId: number;
  title: string;
  body: string;
  readAt: string | null;
  createdAt: string;
}

export function fetchNotifications(
  page = 1,
  signal?: AbortSignal,
): Promise<PageResult<Notification>> {
  return api.get<PageResult<Notification>>('/notifications', {
    query: { page, pageSize: 20 },
    signal,
  });
}

/**
 * Polled by the bell. `silent` suppresses the global loading indicator: a spinner
 * flickering every minute for something nobody asked for is worse than no feedback
 * (PQ-002 read the right way round).
 */
export function fetchUnreadCount(signal?: AbortSignal): Promise<{ count: number }> {
  return api.get<{ count: number }>('/notifications/unread-count', { signal, silent: true });
}

export function markNotificationRead(id: number): Promise<void> {
  return api.post<void>(`/notifications/${id}/read`, undefined, { silent: true });
}

export function markAllNotificationsRead(): Promise<void> {
  return api.post<void>('/notifications/read-all');
}
